"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAcfInfo = exports.deleteFavoriteCategory = exports.addFavoriteCategory = exports.getAllPromosData = exports.getAllBounties = exports.getAllCategories = void 0;
var axios_1 = __importDefault(require("axios"));
var catchAxiosError_1 = __importDefault(require("../../util/catchAxiosError"));
function getAllCategories(payload) {
    return axios_1.default.get("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/categories?exclude=205&per_page=100&page=").concat(payload));
}
exports.getAllCategories = getAllCategories;
function getAllBounties(payload) {
    return axios_1.default.get("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/bounty?per_page=100&page=").concat(payload));
}
exports.getAllBounties = getAllBounties;
function getAllPromosData() {
    return axios_1.default.get("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/pages/1040380"));
}
exports.getAllPromosData = getAllPromosData;
function addFavoriteCategory(payload) {
    var category = payload.category, token = payload.token;
    return axios_1.default.post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/category/add-category"), {
        category: category,
        token: token
    });
}
exports.addFavoriteCategory = addFavoriteCategory;
function deleteFavoriteCategory(payload) {
    var category = payload.category, token = payload.token;
    return axios_1.default.post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/category/delete-category"), {
        category: category,
        token: token
    });
}
exports.deleteFavoriteCategory = deleteFavoriteCategory;
function getAcfInfo() {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, axios_1.default
                        .get("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/pages/1038451"))
                        .catch(catchAxiosError_1.default)];
                case 1:
                    result = _b.sent();
                    return [2 /*return*/, (_a = result.data) === null || _a === void 0 ? void 0 : _a.acf];
            }
        });
    });
}
exports.getAcfInfo = getAcfInfo;
